import React from "react";
import Layout from "./Layout";
import { PopupWidget } from "react-calendly";

export const PopupComponent = () => {
  return (
    <div className="popup-widget">
      <PopupWidget
        url="https://calendly.com/kevstreamfog/grab-a-virtual-coffee-with-streamfog-explore-3d-streaming"
        rootElement={document.getElementById("root")}
        text="Schedule time with me"
        textColor="#ffffff"
        color="#7cd959"
      />
    </div>
  );
};

function Agencies() {
  return (
    <div className="leave-top_margin">
      <Layout>
        <PopupComponent />
        <div className="streamer_header">
          <h1>
            The <b className="highlighted">Future</b> of Streaming is
            3-dimensional. <b className="highlighted">Adopt</b> early.
          </h1>
        </div>
        <div className="streamer_body">
          <div className="table_body">
            <h2 className="highlighted">Transform Your Digital Presence</h2>
            <p>
              In a digital ecosystem where Twitch viewership is becoming
              increasingly competitive, standing out is not just an option—it's
              a necessity. Streamfog introduces a game-changing solution for
              esports teams, talent agencies, and advertisers. With our unique
              3D streaming technology, you can provide immersive and
              non-intrusive experiences that resonate with the younger audience.
              Let's redefine what's possible together.
            </p>

            <div className="flex-container">
              <div className="flex-item">
                <h2 className="highlighted">
                  For Esports Teams and Talent Agencies
                </h2>
                <p>
                  Are you an esports organization or a talent agency
                  representing a team of streamers? In a world where growing
                  means outshining others, your clients need more than generic
                  visuals. With Streamfog, you can create customized 3D alerts
                  that interact with the streamer's room, providing a unique and
                  engaging viewing experience. Stand out and grow by offering
                  something truly innovative.
                </p>
                <h3 className="highlighted">Benefits:</h3>
                <ul>
                  <li>Create Unique Experiences, stand out.</li>
                  <li>
                    Collaborate with Our In-House Art Studio, bring your vision
                    to life.
                  </li>
                  <li>Cost-Savings for Multi-Streamer Deals.</li>
                </ul>
              </div>
              <div className="flex-item">
                <h2 className="highlighted">For Advertisers</h2>
                <p>
                  Advertisers know how challenging it can be to reach younger
                  audiences on platforms like Twitch without disrupting the flow
                  of the stream. With Streamfog's 3D ads, you can craft
                  immersive and non-intrusive advertising experiences that truly
                  resonate. Our 3D ads don't just fit into the streamer's room;
                  they belong there, adding value rather than distraction.
                </p>
                <h3 className="highlighted">What we offer:</h3>
                <ul>
                  <li>Immersive Advertising. Engaging and stunning.</li>
                  <li>Non-Intrusive Approach. Experience over interruption.</li>
                  <li>In-House Art Studio Collaboration.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}

export default Agencies;
